var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import EmailIcon from '@mui/icons-material/Email';
import { Introduction } from './sections/Introduction';
import { OurVision } from './sections/OurVision';
import { JoinUs } from './components';
import './nt-colors.css';
import classes from './LandingPage.module.css';
export const LandingPage = (_a) => {
    var { children, className, joinUsProps = {} } = _a, introProps = __rest(_a, ["children", "className", "joinUsProps"]);
    const classNames = className ? `${className} ${classes.main}` : classes.main;
    return (_jsxs(_Fragment, { children: [_jsx("main", Object.assign({ className: classNames }, { children: _jsxs(_Fragment, { children: [_jsx(Introduction, Object.assign({}, introProps)), children, _jsx(OurVision, {})] }) })), _jsx(JoinUs, Object.assign({}, joinUsProps)), _jsxs("footer", Object.assign({ className: classes.footer }, { children: [_jsx("p", { children: "\u00A9 Nordic Trustee" }), _jsx("p", { children: _jsxs("a", Object.assign({ href: 'mailto:portals@nordictrustee.com?subject=Request%20demo' }, { children: [_jsx(EmailIcon, {}), "portals@nordictrustee.com"] })) }), _jsxs("p", { children: [_jsx("a", Object.assign({ href: "https://nordictrustee.com/contact", target: "_blank", rel: "noreferrer" }, { children: "Contact" })), "Contact"] })] }))] }));
};
